
namespace RioERP.Users {
    export class SupportColumns {
        static columnsKey = 'Users.Support';
    }
}